import { useTranslation } from "react-i18next";

const VideoInfluencer = ({ video }) => {
    const { t } = useTranslation();
    return (
        <div className="col-md-4">
            <div className="border al-border-radius-8 px-4 py-3 d-flex flex-column gap-6">
                <div className="d-flex gap-3 align-items-center gap-3">
                    <div className="symbol symbol-45px symbol-circle">
                        <img
                            src={video?.influencer?.avatar_url || require("components/assets/media/misc/image.png")}
                            alt=""
                        />
                    </div>
                    <div className="d-flex flex-column">
                        <div className="fw-bold text-dark">{video?.influencer?.influencer_name}</div>
                        <div className="text-muted">ID: {video?.influencer?.unique_id}</div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="text-center fs-5">
                        <div className="fw-bold">{video?.influencer?.followers_count}</div>
                        <div className="text-muted">{t("Followers")}</div>
                    </div>
                    <div className="text-center fs-5">
                        <div className="fw-bold">{video?.influencer?.likes_count}</div>
                        <div className="text-muted">{t("Likes")}</div>
                    </div>
                    <div className="text-center fs-5">
                        <div className="fw-bold">{video?.influencer?.videos_count}</div>
                        <div className="text-muted">{t("Videos")}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoInfluencer;
